var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { TableCell as MUITableCell } from '@mui/material';
import { useStyles } from './TableCell.styles';
export function TableCell(_a) {
    var { align, children, className, component, id, padding, scope, size, sortDirection, variant, style } = _a, tableCellBaseProps = __rest(_a, ["align", "children", "className", "component", "id", "padding", "scope", "size", "sortDirection", "variant", "style"]);
    const classes = useStyles();
    return (React.createElement(MUITableCell, Object.assign({ align: align, padding: padding, component: component, classes: { root: classes.root }, id: id, scope: scope, size: size, sortDirection: sortDirection, variant: variant, className: className, style: style }, tableCellBaseProps), children));
}
//# sourceMappingURL=TableCell.js.map